<template>
  <div>
    <b-tabs content-class="mt-3">
      <b-tab title="Profile">
        <h4>Your Profile</h4>
        <br>
        <p>Your Full Name:</p>
        <b-form-input
          id="exampleInput1"
          type="text"
          v-model="form.full_name"
          required
          placeholder="Your Full Name"
        ></b-form-input>
        <br>
        <p>Your Birthday:</p>
        <b-form-input type="date" v-model="form.date_of_birth"></b-form-input>
        <br>
        <p>Gender</p>
        <b-form-select v-model="form.gender" :options="gender_options"></b-form-select>
        <br>
        <br>
        <p>Email</p>
        <b-form-input type="email" v-model="user_info.email" disabled></b-form-input>
        <br>
        <p>Address:</p>

        <b-form-textarea v-model="form.address" :rows="3"></b-form-textarea>
        <br>
        <br>
        <p>Name of School/College that you are attending/have graduated from</p>
        <b-form-input type="text" v-model="form.college"></b-form-input>
        <br>
        <br>
        <p>Are you currently employed?</p>
        <b-form-radio-group v-model="form.is_currently_working">
          <b-form-radio value="Yes">Yes</b-form-radio>
          <b-form-radio value="No">No</b-form-radio>
        </b-form-radio-group>
        <br>
        <br>
        <div v-if="form.is_currently_working == 'Yes'">
          <p>Organization Name</p>
          <b-form-input v-model="form.organization"></b-form-input>
          <br>
          <br>
        </div>
        <p>Name of the entrance exam you are appearing for:</p>
        <b-form-input v-model="form.entrance_exam"></b-form-input>
        <br>
        <br>
        <p>Would you like to be contacted by the Admin?</p>
        <b-form-radio-group v-model="form.contactable_by_admin">
          <b-form-radio value="Yes">Yes</b-form-radio>
          <b-form-radio value="No">No</b-form-radio>
        </b-form-radio-group>
        <br>
        <br>
        <p>Would you like to receive notifications?</p>
        <b-form-radio-group v-model="form.receive_notifications">
          <b-form-radio value="Yes">Yes</b-form-radio>
          <b-form-radio value="No">No</b-form-radio>
        </b-form-radio-group>

        <b-button
          class="btn query-btn button-touchy"
          variant="primary"
          style="margin-top: 50px; margin-left:0;"
          @click="execute_save_profile"
        >Save Profile</b-button>
      </b-tab>

      <b-tab title="Account Balance">
        <h4>Available Doubts: {{calculated_credits}}</h4>
        <hr />
        <p>History:</p>
        <b-container fluid class="solution-container" v-for="(transaction,index) in user_info.transactions" :key="transaction.id">
						<b-link class="solution-link note">
							<b-row>
								<b-col lg="2" class="" style="display:flex;flex-direction: column;justify-content: center;">
									<p class="date">{{get_human_date(transaction.created_at)}}</p>
								</b-col>
								<b-col lg="4">
									<p>{{transaction.reference}}</p>
									<!--<p class="doubt-description"><span class="qds-dot qds-active"></span> {{doubt.description.slice(0,50)}}...</p> -->
								</b-col>
								<b-col lg="5" class="sol-rating">
									<!-- <p>Rate Solution:</p> -->
									<!-- <div class="star-rating">
										<font-awesome-icon icon="star" style="color: gold;" />
										<font-awesome-icon icon="star" style="color: gold;" />
										<font-awesome-icon icon="star" style="color: gold;" />
										<font-awesome-icon icon="star" style="color: #fff;" />
										<font-awesome-icon icon="star" style="color: #fff;" />
									</div> -->
								</b-col>
								<b-col lg="1">

									<span class="doubt-description sol-view" style="color:red" v-if="transaction.debit  > 0">-{{transaction.debit}}</span>
			            <span class="doubt-description sol-view" v-else style="color:green">+{{transaction.credit}}</span>

								</b-col>
							</b-row>
						</b-link>
					</b-container>
      </b-tab>


      <b-tab title="Security">
        <h4>Update Password</h4>
        <br>

        <div class="password_wrapper">
          <p>Current Password</p>
          <b-form-input v-model="form_password.old_password" type="password"></b-form-input>
          <br>
          <p>New Password</p>
          <b-form-input v-model="form_password.new_password" type="password"></b-form-input>
          <br>
          <p>Repeat New Password</p>
          <b-form-input v-model="form_password.new_password_repeat" type="password"></b-form-input>
        </div>

        <b-button
          class="btn query-btn button-touchy"
          variant="primary"
          style="margin-top: 30px; margin-left:0;"
          @click="execute_save_password"
        >Update Password</b-button>
      </b-tab>

      
    </b-tabs>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Account",
  data: function() {
    return {
      gender_options: ["Male", "Female", "Others", "Prefer not to say"],
      form: {
        full_name: "",
        date_of_birth: "",
        gender: "",
        email: "",
        mobile: "",
        address: "",
        college: "",
        is_currently_working: "",
        organization: "",
        entrance_exam: "",
        contactable_by_admin: "",
        receive_notifications: ""
      },
      form_password: {
        old_password: "",
        new_password: "",
        new_password_repeat:""
      }
    };
  },
  computed: {
    user_info: function() {
      return this.$store.getters.user;
    },
    calculated_credits: function() {
      if(this.user_info.credits.credit != null) {
        if(this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit)
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetch_user_transactions');
    this.form.full_name = this.user_info.full_name;
    if (
      this.user_info.date_of_birth != null &&
      this.user_info.date_of_birth != ""
    ) {
      this.form.date_of_birth = moment(this.user_info.date_of_birth).format(
        "YYYY-MM-DD"
      );
    }

    this.form.gender = this.user_info.gender;
    this.form.address = this.user_info.address;
    this.form.college = this.user_info.college;
    this.form.is_currently_working = this.user_info.is_currently_working;
    this.form.organization = this.user_info.organization;
    this.form.entrance_exam = this.user_info.entrance_exam;
    this.form.contactable_by_admin = this.user_info.contactable_by_admin;
    this.form.receive_notifications = this.user_info.receive_notifications;
  },
  methods: {
    execute_save_profile: async function() {
      this.$store.commit("setLoader", true);
      var result = await this.$store.dispatch("save_profile", this.form);
      this.$toasted.show("Profile Saved", { type: "success" });
      this.$store.commit("setLoader", false);
    },
    get_human_date(d) {
	      let mom = moment(d);
	      return mom.format('LL');
	  },
    execute_save_password: async function() {

      if(this.form_password.new_password != this.form_password.new_password_repeat) {
        this.$toasted.show("Please make sure that the Password and Repeat Password match", { type: "error" });
        return;
      }


      this.$store.commit("setLoader", true);
      try {
        var result = await this.$store.dispatch("save_password",this.form_password);
        this.$toasted.show("Password Updated", { type: "success" });
      } catch(ex) {
        this.$toasted.show("Could not save password", { type: "error" });
      }
    
      this.$store.commit("setLoader", false);
    }
  }
};
</script>

<style scoped>
.sol-rating {
	display: inline-flex;
	justify-content: space-evenly;
	align-items: center;
}
.solution-link {
	background-color: #fff;
	margin: 10px 0px;
	display: block;
	color: black;
	padding: 20px;
}
.solution-link p {
	margin: 0;
}
.star-rating {
  line-height:32px;
  font-size:1.25em;
}
.sol-view {
	font-size: 3rem;
	line-height: 3rem;
	text-align: right;
}
.text-center {
	text-align: center;
}
.solution-link {
	border-left: 5px solid;
	border-color: #959090;
}
.qds-active-border {
	border-color:  #AACF37;
}

.doubt-description {
    /*display: none;*/
    font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Account.vue